import { render } from "./ProductsCategory.vue?vue&type=template&id=1f5276b6"
import script from "./ProductsCategory.vue?vue&type=script&scoped=true&lang=js"
export * from "./ProductsCategory.vue?vue&type=script&scoped=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__